import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const AdminProtectedRoute = ({ children, user }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      console.log("AdminProtectedRoute: Checking admin role for user:", user?.uid);
      
      if (!user) {
        console.log("AdminProtectedRoute: No user found");
        setLoading(false);
        return;
      }

      try {
        // Get user document from Firestore to check role
        const userDocRef = doc(db, "users", user.uid);
        console.log("AdminProtectedRoute: Getting user document for:", user.uid);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log("AdminProtectedRoute: User data found:", userData);
          const isUserAdmin = userData.role === "admin";
          console.log("AdminProtectedRoute: Is user admin?", isUserAdmin);
          setIsAdmin(isUserAdmin);
        } else {
          console.log("AdminProtectedRoute: User document doesn't exist");
          // If user document doesn't exist, they're not admin
          setIsAdmin(false);
        }
      } catch (error) {
        console.error("AdminProtectedRoute: Error checking admin role:", error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminRole();
  }, [user]);

  console.log("AdminProtectedRoute: Render - loading:", loading, "user:", !!user, "isAdmin:", isAdmin);

  if (loading) {
    return <div>Loading...</div>; // Or your loading component
  }

  if (!user) {
    console.log("AdminProtectedRoute: Redirecting to / - no user");
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    console.log("AdminProtectedRoute: Redirecting to /plans - not admin");
    return <Navigate to="/plans" replace />; // Redirect to regular user area
  }

  console.log("AdminProtectedRoute: Allowing access to admin area");
  return children;
};
